import { defineMessages } from 'react-intl-next';

export const messages: {
    descriptionFieldLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; linkFieldLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; recommendedFieldLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; titleFieldLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	linkFieldLabel: {
		id: 'company-hub.cards-extension.config-panel.link.field.label',
		defaultMessage: 'Link',
		description: 'Visible label for link field in the link cards config panel',
	},
	titleFieldLabel: {
		id: 'company-hub.cards-extension.title.field.label',
		defaultMessage: 'Title',
		description: 'Visible label for title field in the link cards config panel',
	},
	recommendedFieldLabel: {
		id: 'company-hub.cards-extension.recommended.field.label',
		defaultMessage: '(Recommended)',
		description: 'Visible `recommended` label for the title field in the link cards config panel',
	},
	descriptionFieldLabel: {
		id: 'company-hub.cards-extension.description.field.label',
		defaultMessage: 'Description',
		description: 'Visible label for description field in the link cards config panel',
	},
});
